<template>
	<div>
		<div class="seatBindingBtn">
			<el-button size="medium" type="primary" @click="addBinding">添加</el-button>
			<el-button size="medium" type="danger" @click="delBinding" :disabled="selectBind.length == 0">
				删除<span v-if="selectBind.length > 0">({{ selectBind.length }})</span>
			</el-button>
		</div>
		<el-table v-loading="loading" class="tableStyle" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" align="center"></el-table-column>
			<el-table-column prop="userName" label="访员姓名" width="180" align="center"></el-table-column>
			<el-table-column prop="clientId" label="工号" width="180" align="center"></el-table-column>
			<el-table-column prop="dstName" label="绑定服务器名称" width="180" align="center"></el-table-column>
			<el-table-column prop="password" label="密码" width="180" align="center"></el-table-column>
			<el-table-column prop="clientIp" label="客户机IP(模拟线)" align="center"></el-table-column>
			<el-table-column fixed="right" label="操作" width="120" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="deitBinding(scope)" type="text">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pagination.pageNo"
				:page-sizes="[10, 50, 100, 200, 300, 400]"
				:page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pagination.total"
			></el-pagination>
		</div>

		<!-- 添加修改 详情 -->
		<seatBindingDetails ref="seatBindingDetails" @bindingOk="bindingOk"></seatBindingDetails>
	</div>
</template>

<script>
import seatBindingDetails from './seatBindingDetails';
export default {
	components: {
		seatBindingDetails
	},
	data() {
		return {
			selectBind: [],
			tableData: [],
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			loading: false
		};
	},
	created() {
		this.loadData();
	},
	methods: {
		bindingOk() {
			this.loadData();
		},
		// 编辑
		deitBinding(scope) {
			let data =  JSON.parse(JSON.stringify(scope.row));
			console.log(data)
			
			data.uid = data.uid.split(',')
			if (data.isPassWord == 1) {
				data.isPassWord = true;
			} else {
				data.isPassWord = false;
			}
			data.clientIp = data.clientId;
			delete data.createId;
			this.$refs.seatBindingDetails.form = data;
			this.$refs.seatBindingDetails.editDetails();
		},
		// 添加
		addBinding() {
			this.$refs.seatBindingDetails.addDetails();
		},
		handleSelectionChange(val) {
			let tempSelectBind = [];
			val.forEach(item => {
				tempSelectBind.push(item.id);
			});
			this.selectBind = tempSelectBind;
		},
		delBinding() {
			if(this.selectBind.length==0){
				this.$message.warning('请选择一条数据');
				return false
			}
			this.$confirm('确定删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.bindDel}?ids=${that.selectBind.toString()}`,
						method: 'GET',
						data: {},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.pageNo = 1;
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
		},
		loadData() {
			this.loading = true
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.bindList}?pageIndex=${this.pagination.pageNo}&pageSize=${this.pagination.pageSize}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.datas;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
					}
				},
				finally() {
					that.loading = false
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style>
.seatBindingBtn {
	display: flex;
	justify-content: space-between;
}
.tableStyle {
	margin-top: 20px;
}
.block {
	text-align: right;
	margin-top: 20px;
}
</style>
